import styled from 'styled-components'
import {
    textColorStyles,
    textSizeStyles,
    textWeightStyles,
} from './text/textStyles'

export const Chip = styled.div`
    display: flex;
    padding: 4px 6px;
    justify-content: center;
    align-items: center;
    gap: 10px;

    border-radius: 8px;
    margin-top: auto;

    ${textSizeStyles['xSmall']}
    ${textWeightStyles['medium']}
`

export const PrimaryChip = styled(Chip)`
    border: ${(p) => `1px solid ${p.theme.colors.primaryGreen}`};
    background: ${(p) => p.theme.colors.white};

    ${textColorStyles['brand']}
`

export const SecondaryChip = styled(Chip)`
    border: ${(p) => `1px solid ${p.theme.colors.tertiary.tertiary50}`};
    background: ${(p) => p.theme.colors.tertiary.tertiary50};

    ${textColorStyles['secondary']}
`
